module.exports = __webpack_public_path__ + "img/mullins-ck3-assassin.423d0ef6.webp";